/*!
 * Copyright (c) 2017-present Cliqz GmbH. All rights reserved.
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
/* tslint:disable quotemark */
export default [
  "\\/[a-d][-\\.\\/_A-Za-z][DHWXm][-\\.\\/_A-Za-z][59FVZ][-\\.\\/_A-Za-z][6swyz][-\\.\\/_A-Za-z][-\\/_0-9a-zA-Z][-\\.\\/_A-Za-z][-\\/_0-9a-zA-Z]{22,162}$/",
  "/homad-global-configs.schneevonmorgen.com/global_config",
  "/etc.clientlibs/logitech-common/clientlibs/onetrust.",
  "/templates/base_master/js/jquery.shows.min.js",
  "/pagead/managed/js/gpt/*/pubads_impl.js",
  "\\?aHR0c[\\/0-9a-zA-Z]{33,}=?=?$/",
  "/pagead/js/adsbygoogle.js",
  "/fileadmin/user_upload/",
  "[+\\/0-9a-zA-Z]{140,}$/",
  "/js/sdkloader/ima3.js",
  "/wp-content/uploads/*",
  "/wp-content/plugins/",
  "/wp-content/uploads/",
  "/detroitchicago/",
  "/appmeasurement",
  "/cdn-cgi/trace",
  "/^https?:\\/\\/",
  "[a-zA-Z0-9]{",
  "/^https:\\/\\/",
  "/wp-content/",
  "atellitelib-",
  "impression",
  "[0-9a-f]{",
  "[0-9a-z]{",
  "/template",
  "affiliate",
  "analytics",
  "/assets/",
  "/images/",
  "tracking",
  "300x250",
  "collect",
  "consent",
  "content",
  "counter",
  "default",
  "sponsor",
  "visitor",
  ".aspx?",
  "/media",
  "728x90",
  "banner",
  "client",
  "cookie",
  "google",
  "metric",
  "prebid",
  "rivacy",
  "script",
  "source",
  "widget",
  ".cgi?",
  ".com/",
  ".html",
  "/api/",
  "/file",
  "/html",
  "/img/",
  "/java",
  "/page",
  "/stat",
  "/uplo",
  "a-z]{",
  "block",
  "click",
  "count",
  "event",
  "frame",
  "image",
  "manag",
  "pixel",
  "track",
  "video",
  ".gif",
  ".jpg",
  ".php",
  ".png",
  "/jqu",
  "/js/",
  "/lib",
  "/log",
  "/web",
  "468x",
  "bung",
  "gdpr",
  "gi-b",
  "http",
  "ight",
  "page",
  "stat",
  "view",
  ".js",
  "/ad",
  "/js",
  "^*/",
  "=*&",
  "com",
  "eck",
  "ext",
  "gpt",
  "how",
  "ify",
  "ive",
  "jax",
  "key",
  "lay",
  "log",
  "lug",
  "sdk",
  "tag",
  "und",
  "web",
  "ync",
  "-p",
  ".m",
  "*^",
  "/_",
  "/?",
  "/*",
  "/d",
  "/f",
  "/g",
  "/h",
  "/l",
  "/m",
  "/n",
  "/p",
  "/r",
  "/w",
  "\\.",
  "\\/",
  "00",
  "a-",
  "ac",
  "ad",
  "ag",
  "al",
  "am",
  "an",
  "ap",
  "ar",
  "as",
  "at",
  "be",
  "bo",
  "ce",
  "ch",
  "co",
  "ct",
  "de",
  "e_",
  "e-",
  "e/",
  "ed",
  "el",
  "em",
  "en",
  "er",
  "et",
  "ew",
  "ff",
  "g/",
  "ic",
  "id",
  "ig",
  "il",
  "im",
  "in",
  "is",
  "it",
  "la",
  "le",
  "li",
  "lo",
  "mo",
  "mp",
  "ol",
  "om",
  "on",
  "op",
  "or",
  "ot",
  "re",
  "ro",
  "s_",
  "s-",
  "s?",
  "s/",
  "sp",
  "ss",
  "st",
  "t/",
  "tm",
  "tn",
  "tr",
  "ub",
  "um",
  "un",
  "up",
  "ur",
  "us",
  "ut",
  "_",
  "-",
  ",",
  ":",
  "?",
  ".",
  "(",
  ")",
  "[",
  "}",
  "*",
  "/",
  "&",
  "^",
  "=",
  "|",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z"
];